import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { LANGUAGE } from '../../../cartAndOrders/constant'
import { ExternalLink } from '../../../common/ExternalLink'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { PopupAction } from '../../../common/popup/PopupAction'
import {
  changeOwnershipStructureFilter,
  keyLoading,
  selectLoading,
  selectOwnershipStructureHistoryData,
  selectOwnershipStructureHistoryFilter,
  selectOwnershipStructureHistoryIds,
} from '../store/slice'
import { getOwnershipHistorical } from '../store/thunk'
import { OwnershipStructureTable } from './OwnershipStructureTable'

export const PopupOSHistory = ({ onClose }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const isLoadingDetailHistory = useSelector(
    selectLoading(keyLoading.DETAIL_HISTORY),
  )
  const filter = useSelector(selectOwnershipStructureHistoryFilter)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const getDisclaimerHyperlink =
    locale === LANGUAGE.EN
      ? 'https://fiingate.vn/Home/DataPolicy'
      : 'https://fiingate.vn/Home/DataPolicy?lang=vi-vn'

  const handleChangeSort = (sort) => {
    dispatch(changeOwnershipStructureFilter(sort))
  }

  useEffect(() => {
    dispatch(
      getOwnershipHistorical({
        OrganizationId: organizationId,
        Sort: filter.sortBy === 'publicDateId' ? 'PublicDate' : 'Name',
        SortDirection: filter.sortDirection,
      }),
    )
  }, [locale, organizationId, filter.sortBy, filter.sortDirection])

  return (
    <PopupAction
      title="companyAnalysis.ownershipAndGroup.HISTORICAL_OWNERSHIP"
      appendStyle={{
        padding: '20px',
        backgroundColor: '#F3F3F3',
        width: 900,
        borderRadius: '4px',
      }}
      isShow={true}
      handleClose={onClose}
    >
      <div style={{ marginBottom: 20 }}>
        <Element
          elementName="span"
          className="fstItalic"
          style={{ fontSize: 10 }}
        >
          <Translate value="companyAnalysis.ownershipAndGroup.HISTORICAL_OWNERSHIP_DISCLAIMER" />
          <ExternalLink href={getDisclaimerHyperlink}>
            <Translate value="companyAnalysis.ownershipAndGroup.HISTORICAL_OWNERSHIP_DISCLAIMER_DATA_POLICY" />
          </ExternalLink>
          <Translate value="companyAnalysis.ownershipAndGroup.HISTORICAL_OWNERSHIP_DISCLAIMER_NOTE1" />
        </Element>
      </div>

      <div className="positionRelative" style={{ minHeight: 300 }}>
        {isLoadingDetailHistory ? (
          <Loading />
        ) : (
          <OwnershipStructureTable
            getIdFromRedux={selectOwnershipStructureHistoryIds}
            getDataFromRedux={selectOwnershipStructureHistoryData}
            isHistory
            sort={filter}
            onChangeSort={handleChangeSort}
          />
        )}
      </div>
    </PopupAction>
  )
}
